import { CircularProgress, Typography } from '@mui/material';
import { ActionCenterWidget, BreadcrumbsNavigation, Container } from 'common/components';
import { CircularProgressWrapper } from 'globalStyles';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchReportsSchema } from 'store/actions/advocacyReports';
import { campaignsSelectors } from 'store/selectors/campaigns';
import Grid from 'material/components/Grid';
import styled from 'styled-components';
import CampaignReportsTopCard from '../../CampaignReports/components/CampaignReportsTopCard';
import ActionCenterListWidget from '../components/ActionCenterListWidget';
import OfficialsLookupWidget from '../components/OfficialsLookupWidget';

const CampaignWidgetsWrapper = styled.div`
  margin-bottom: 16px;
  border-radius: 8px;
  padding: 24px;
  background-color: #fff;
`;

const WidgetTitle = styled(Typography)`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 20px;
`;

const WidgetDescription = styled(Typography)`
  margin-bottom: 24px;
  color: #666;
`;

export const CampaignWidgetSectionTitle = styled(Typography)`
  margin-bottom: 12px;
  color: #616161;
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CampaignWidgets = () => {
  const { campaignUuid, organizationUuid } = useParams();
  const dispatch = useDispatch();

  const { campaignReportsSchema, isCampaignReportsSchemaFetching } = useSelector(state => ({
    campaignReportsSchema: campaignsSelectors.getCampaignReportsSchema(state),
    isCampaignReportsSchemaFetching: campaignsSelectors.isCampaignReportsSchemaFetching(state),
  }));

  useEffect(() => {
    dispatch(fetchReportsSchema(organizationUuid));
  }, [dispatch, campaignUuid, organizationUuid]);

  if (isCampaignReportsSchemaFetching || !campaignReportsSchema) {
    return (
      <CircularProgressWrapper>
        <CircularProgress />
      </CircularProgressWrapper>
    );
  }

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/campaigns`,
      name: 'Advocacy',
    },
    {
      name: 'Widgets',
    },
  ];

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container marginBottom="40">
        <Grid container>
          <CampaignReportsTopCard
            title="Widgets"
            backButtonLink={`/${organizationUuid}/campaigns/`}
          />
        </Grid>
        <CampaignWidgetsWrapper>
          <CampaignWidgetSectionTitle variant="body2">Take Action</CampaignWidgetSectionTitle>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <WidgetTitle variant="h6">Action Center Widget</WidgetTitle>
              <WidgetDescription variant="body2">
                Allow advocates to take action from a form embedded in your own website.
              </WidgetDescription>
              <ActionCenterWidget reportsSchema={campaignReportsSchema} />
            </Grid>
          </Grid>
        </CampaignWidgetsWrapper>

        <CampaignWidgetsWrapper>
          <CampaignWidgetSectionTitle variant="body2">
            List Action Centers
          </CampaignWidgetSectionTitle>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <ActionCenterListWidget reportsSchema={campaignReportsSchema} />
            </Grid>
          </Grid>
        </CampaignWidgetsWrapper>
        <CampaignWidgetsWrapper>
          <CampaignWidgetSectionTitle variant="body2">
            Find Your Officials
          </CampaignWidgetSectionTitle>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <OfficialsLookupWidget />
            </Grid>
          </Grid>
        </CampaignWidgetsWrapper>
      </Container>
    </>
  );
};

export default CampaignWidgets;
